import { NavBarSearchKeys } from "components/NavBarSearch/queryKeys";
import { SEARCH_OPTION_TYPE, getFormattedAndSortedSearchResults } from "components/NavBarSearchAppointments/util";
import { useTypedQuery } from "hooks/useTypedQuery";
import { ApiInstance } from "utils/Api";

import type { DealerLocation } from "models";

const formatDmsSearchResults = getFormattedAndSortedSearchResults(SEARCH_OPTION_TYPE.Dms);

export const useDmsAppointmentSearchQuery = (searchTerm: string, selectedLocation?: DealerLocation | null) =>
  useTypedQuery({
    queryKey: NavBarSearchKeys.dmsAppointmentSearchResults,
    queryFn: async ({ endpoint, baseUrl }) =>
      (await ApiInstance.post(endpoint, { dealer_location_id: selectedLocation?.id, limit: 20, page: 0, term: searchTerm }, baseUrl)).data.appointments,
    enabled: false,
    select: formatDmsSearchResults
  });
